import PropTypes from 'prop-types';
import { Avatar } from 'components';
import { NOTIFICATION_TYPES } from '../../utils/constant';
import {
  calculateShortTimeRemaining,
  calculateTimeAgo,
} from '../../utils/helper';
import './NotificationCard.scss';

const NotificationCard = ({
  notification,
  markAsRead,
  onSelect,
  isSelected,
}) => {
  const status =
    typeof notification?.status === 'string'
      ? notification.status
      : NOTIFICATION_TYPES.PENDING;
  const statusClassName = status ? status.toLowerCase() : '';

  const timeAgo = calculateTimeAgo(notification.createdAt);
  const timeLeft =
    notification.type === 'proposal'
      ? calculateShortTimeRemaining(notification.createdAt)
      : null;

  const handleClick = () => {
    // To view Details of Notification

    if (typeof markAsRead === 'function' && !notification.isRead) {
      markAsRead(notification.id);
    }

    if (typeof onSelect === 'function') {
      onSelect(notification);
    }
  };

  return (
    <div
      className={`notification-card ${
        notification.isRead
          ? 'notification-card--read'
          : 'notification-card--unread'
      } ${isSelected ? 'notification-card--selected' : ''}`}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      role='button'
      tabIndex={0}
      aria-current={isSelected ? 'true' : undefined}
    >
      <div className='card-header'>
        <div className='company-info'>
          <Avatar
            size='md'
            src={notification.logo}
            name={notification.company}
          />
          <span className='company-name'>{notification.company}</span>
          {!notification.isRead && <span className='unread-dot' />}
        </div>
        <div className='meta-info'>
          <span className='time-ago'>{timeAgo}</span>
          {timeLeft && <span className='time-left'>{timeLeft}</span>}
          {status && status !== NOTIFICATION_TYPES.PENDING && (
            <span className={`status-text ${statusClassName}`}>{status}</span>
          )}
        </div>
      </div>

      <div className='card-content'>
        <h3>{notification.title}</h3>
        <p>{notification.description}</p>
      </div>

      <div className='card-footer'>
        <span className={`status-badge ${statusClassName}`}>{status}</span>
      </div>
    </div>
  );
};

NotificationCard.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    company: PropTypes.string,
    logo: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    status: PropTypes.string,
    createdAt: PropTypes.string,
    type: PropTypes.string,
    isRead: PropTypes.bool,
  }).isRequired,
  markAsRead: PropTypes.func,
  onSelect: PropTypes.func,
  isSelected: PropTypes.bool,
};

export default NotificationCard;
